import { DownloadOutlined } from '@ant-design/icons';
import { getGetFrontRichiesteIdModuliIdSezioniIdFileCodiceQueryOptions } from '@framework/api-client';
import { useTranslation } from '@framework/i18n';
import { Button, message } from 'antd';
import { useHasDocumentsInlineViewer } from '../../../../ui/documents/useHasDocumentsInlineViewer';
import { useAuthDownload } from '../../../../utils/download/useAuthDownload';

export interface IWidgetDownloadButtonProps {
  submissionId: string;
  submissionModuleId: string;
  sectionId: string;
  code: string;
  filename: string;
  /** ID del file */
  id: string;
  omissis?: boolean;
}

export function WidgetDownloadButton(props: IWidgetDownloadButtonProps) {
  const {
    sectionId,
    submissionId,
    submissionModuleId,
    code,
    filename,
    id,
    omissis,
  } = props;
  const hasInlineViewer = useHasDocumentsInlineViewer();
  const { t } = useTranslation();

  const { download, isFetching } = useAuthDownload(
    getGetFrontRichiesteIdModuliIdSezioniIdFileCodiceQueryOptions,
    [
      submissionId,
      submissionModuleId,
      sectionId,
      code,
      { omissis: omissis, idAllegato: id },
    ],
    {
      filename: filename,
      onError: e => {
        if (e.response?.status === 404) {
          message.error('File non trovato');
          return;
        }

        message.error(
          'Si è verificato un problema durante il download del file. Riprovare.',
        );
      },
      showInlineViewer: hasInlineViewer,
    },
  );

  return (
    <Button
      aria-label={t('upload-widget.filelist.download-file', 'Scarica File')}
      icon={<DownloadOutlined />}
      size={'small'}
      onClick={() => {
        download();
      }}
      loading={isFetching}
    />
  );
}
